// @flow

import { type Node } from 'react';
import { useReloadAfterPaymentGetsConfirmedOrCanceled } from './use-reload-after-payment-gets-confirmed-or-canceled';

export function ReloadAfterPaymentGetsConfirmedComponent(): Node {
  useReloadAfterPaymentGetsConfirmedOrCanceled();
  return null;
}
